import { createApiClient } from "Network/ApiClient";

export const PatientRelationAxiosInstance = createApiClient("patient/");
